import { bindTooltip } from "../../../vendors/tooltips";

Vue.component("offer-filters", {
	delimiters: ["{[{", "}]}"],
	props: ["filters", "dataofferurl", "urlfilters"],
	data() {
		return {
			filters: this.filters,
            filtersVisibility: false,
            periodValue: null,
			filtersObj: {},
			btnVisibility: false,
			urlfilters: this.urlfilters,
		}
	},
	template: '#offer-filters',
	computed: {
		computedPeriodValue() {
			const periodFilterIndex = this.filters.parameters.elements.findIndex(filter => filter.period == true);
			if (this.periodValue) {
				return this.periodValue;
			} else if (this.filters.parameters.elements[periodFilterIndex]) {
				const optionIndex = this.filters.parameters.elements[periodFilterIndex].options.findIndex(option => option.active == true);
				if (optionIndex > -1) {
					if (this.filters.parameters.elements[periodFilterIndex].period) {
						return this.filters.parameters.elements[periodFilterIndex].options[optionIndex].text
					}
				}
			} else if (this.filters.parameters.switchPeriod.value) {
				return this.filters.parameters.switchPeriod.value;
			}
		},
		activeFilters() {
			let activeFilters = {};
			if (this.filters) {
				const actFilters = this.filters.parameters.elements;
				actFilters.forEach(filter => {
					const options = filter.options;
					for (let i = 0; i < options.length; i++ ) {
					if (options[i].active) {
						if (options[i].type == "radio") {
							activeFilters[`${options[i].query_parameter}`] = `${options[i].query_value}`;
						} else if (options[i].type == "checkbox") {
							activeFilters[`${options[i].query_parameter}`] = activeFilters[`${options[i].query_parameter}`] ? activeFilters[`${options[i].query_parameter}`] + `_${options[i].query_value}` : options[i].query_value;
						}
					}
				}
				});
			}
			return activeFilters;
		}
	},
	updated() {
		// console.log("urlfilters in updated filters", this.urlfilters);
    },
    methods: {
        showFilters() {
			this.filtersVisibility = !this.filtersVisibility;
        },
        changePeriod(value) {
            // console.log(value)
            this.periodValue = value;
        },
		emitFilters(option, event) {
			// console.log(this.activeFilters);
			this.filtersObj = this.activeFilters;
			// console.log("this.filtersObj before click", this.filtersObj);
			// console.log("event.target.getAttribute('checked')", event.target.checked);
			if (event.target.checked) {
				if (option.type == 'radio' && !option.disabled) {
					this.filtersObj[`${option.query_parameter}`] = option.query_value;
				} else if (option.type == 'checkbox' && !option.disabled) {
					// console.log("clicked checkbox", `${option.query_parameter}=${option.query_value}`);
					let oldFilterId = (this.filtersObj[`${option.query_parameter}`] && this.filtersObj[`${option.query_parameter}`] != option.query_value) ? this.filtersObj[`${option.query_parameter}`] + `_${option.query_value}` : option.query_value;
					// console.log("oldFilterId", oldFilterId);
					this.filtersObj[`${option.query_parameter}`] = oldFilterId;
					// console.log("this.filtersObj[`${option.query_parameter}`]", this.filtersObj[`${option.query_parameter}`]);

					const dashIndex = this.filtersObj[`${option.query_parameter}`].indexOf("_");
					const doubleDashIndex = this.filtersObj[`${option.query_parameter}`].indexOf("__");
					if (dashIndex == 0 || dashIndex == this.filtersObj[`${option.query_parameter}`].length - 1) {
						this.filtersObj[`${option.query_parameter}`] = this.filtersObj[`${option.query_parameter}`].replace("_", "");
					}
					if (doubleDashIndex == 0 || doubleDashIndex == this.filtersObj[`${option.query_parameter}`].length - 1) {
						this.filtersObj[`${option.query_parameter}`] = this.filtersObj[`${option.query_parameter}`].replace("__", "");
					}
					if (this.filtersObj[`${option.query_parameter}`] == 0 || this.filtersObj[`${option.query_parameter}`] == "_" || this.filtersObj[`${option.query_parameter}`] == "__") {
						delete this.filtersObj[`${option.query_parameter}`];
					}
				}
			} else {
				if (option.type == 'checkbox' && !option.disabled) {
					// console.log("trzeba usunąć z urla", option.query_value, this.filtersObj[`${option.query_parameter}`].includes(option.query_value));
					if (this.filtersObj[`${option.query_parameter}`].includes(option.query_value)) {
						this.filtersObj[`${option.query_parameter}`] = this.filtersObj[`${option.query_parameter}`].replace(option.query_value, "");
						// console.log("po usunięciu", this.filtersObj[`${option.query_parameter}`]);
						const dashIndex = this.filtersObj[`${option.query_parameter}`].indexOf("_");
						const doubleDashIndex = this.filtersObj[`${option.query_parameter}`].indexOf("__");
						if (dashIndex == 0 || dashIndex == this.filtersObj[`${option.query_parameter}`].length - 1) {
							this.filtersObj[`${option.query_parameter}`] = this.filtersObj[`${option.query_parameter}`].replace("_", "");
						}
						if (doubleDashIndex == 0 || doubleDashIndex == this.filtersObj[`${option.query_parameter}`].length - 1) {
							this.filtersObj[`${option.query_parameter}`] = this.filtersObj[`${option.query_parameter}`].replace("__", "");
						}
						if (this.filtersObj[`${option.query_parameter}`] == 0 || this.filtersObj[`${option.query_parameter}`] == "_" || this.filtersObj[`${option.query_parameter}`] == "__") {
							delete this.filtersObj[`${option.query_parameter}`];
						}
					}
				}
			}
			// console.log("this.filtersObj[`${option.query_parameter}`]", this.filtersObj[`${option.query_parameter}`]);
			
			const filtersEmitted = {'filtersObj': this.filtersObj};
			// console.log("emitted: ", this.filtersObj, " and active: ", this.activeFilters);
			this.$emit('changed-filters', filtersEmitted);
		},
		showBtn() {
			if (!this.btnVisibility) {
				this.btnVisibility = true;
			}
		},
		paramsCleaning(paramVal, paramsObj, key, i) {
			if (paramVal.includes("__")) {
				paramVal = paramVal.replace("__", "_");
				paramsObj[`${key[i]}`] = paramVal;
			}
			if (paramVal.indexOf("_") == 0) {
				paramVal = paramVal.replace("_", "");
				paramsObj[`${key[i]}`] = paramVal;
			}
			if (paramVal.indexOf("_") == paramVal.length - 1) {
				paramVal = paramVal.replace("_", "");
				paramsObj[`${key[i]}`] = paramVal;
			}
			if (paramVal == '_' || paramVal == '__' || paramVal == '') {
				delete paramsObj[`${key[i]}`];
			}
		},
	},
});